import { useUpdateUserSettings } from 'features/user';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { useUpcomingSelectedView } from 'shared/hooks/use-upcoming-selected-view';
import { UpcomingViewOptions } from 'shared/types/upcoming-view-options';
import { targetIsInput } from 'shared/utils/target-is-input';

export const useSelectedView = () => {
  const { view, isCalendarAllowed } = useUpcomingSelectedView();

  const openPremiumDialog = useOpenPremiumDialog();
  const updateUserSettings = useUpdateUserSettings();

  const setView = (view: UpcomingViewOptions) => {
    if (view === UpcomingViewOptions.Calendar && !isCalendarAllowed) {
      openPremiumDialog();
      return;
    }

    updateUserSettings({ upcoming: { webView: view } });
  };

  useKeysDown(
    ['KeyL'],
    (e) => {
      if (targetIsInput(e.target)) {
        return; // Don't open dialog
      }
      setView(UpcomingViewOptions.List);
    },
    { otherKeysInCombinationAllowed: true },
  );

  useKeysDown(
    ['KeyC'],
    (e) => {
      if (targetIsInput(e.target)) {
        return; // Don't open dialog
      }
      setView(UpcomingViewOptions.Calendar);
    },
    { otherKeysInCombinationAllowed: true },
  );

  return {
    view,
    setView,
  };
};
